import classNames from "classnames";
import React, {
    HTMLAttributes,
    ReactNode,
    useMemo,
} from "react";
import Styles from "./FilterList.module.scss";
import FilterButton, { Type as FilterButtonType } from "./FilterButton";
import { FilterListContext, FilterListState } from "./base";

export interface FilterListProps<T> extends HTMLAttributes<HTMLDivElement> {
    selectedItem?: T;
    onChangeSelected?: (item: T) => void;
}

const FilterListComponent = React.forwardRef(<T, >(
    args: FilterListProps<T>,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactNode => {
    const {
        className,
        children,
        selectedItem,
        onChangeSelected,
        ...rest
    } = args;

    const provider = useMemo(() => new FilterListState<T>(onChangeSelected), []);

    provider.useSelected(selectedItem);

    return (
        <FilterListContext.Provider value={provider as FilterListState}>
            <div ref={ref} className={classNames(Styles["filter-list"], className)} {...rest}>
                {children}
            </div>
        </FilterListContext.Provider>
    );
});

FilterListComponent.defaultProps = {

};

export type Type<T> = (
    props: FilterListProps<T> & { ref?: React.ForwardedRef<HTMLDivElement> }
) => ReactNode;

type FilterListWithTypes<T = unknown> = Type<T> & {
    Button: FilterButtonType<T>;
}
const FilterList = FilterListComponent as unknown as FilterListWithTypes;
FilterList.Button = FilterButton;

export default (() => FilterList) as <T>() => FilterListWithTypes<T>;
